var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoticeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 60C47.0163 60 60 47.0163 60 31C60 14.9837 47.0163 2 31 2C14.9837 2 2 14.9837 2 31C2 47.0163 14.9837 60 31 60Z",
    stroke: "#F1C44D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 43.5C34 44.8807 32.8807 46 31.5 46C30.1193 46 29 44.8807 29 43.5C29 42.1193 30.1193 41 31.5 41C32.8807 41 34 42.1193 34 43.5Z",
    fill: "#F1C44D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 17,
    width: 5,
    height: 20,
    rx: 2.5,
    fill: "#F1C44D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeIcon);
export default __webpack_public_path__ + "static/media/NoticeIcon.acbcdbf591bd73faa090706f88da9dff.svg";
export { ForwardRef as ReactComponent };